import { useEffect, useState } from 'react';

import Link from 'next/link';

import { RightArrowIcon, ChevronRight } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import {
  HeaderCampaignItemViewModel,
  HeaderSubCategoryItemViewModel,
} from '@api/v3';
import { addMenuClickEventsToGTM } from '@utils/gtm/menu-click-events-gtm';
import { productImpression } from '@utils/newDataLayer/productImpression';

import {
  Item,
  ItemLink,
  ItemSubItemBox,
  ItemSubItemLink,
  ItemsWrapper,
  ItemTitle,
  PhotosItem,
  PhotosItemBorder,
  PhotosItemContent,
  PhotosItemLabel,
  PhotosItemImage,
  PhotosWrapper,
  Wrapper,
  LinksItems,
  ItemLinkContainer,
  ItemLinkDyanmic,
  ChevronContainer,
} from './MegaMenuStyle';

export interface MegaMenuProps {
  items?: HeaderSubCategoryItemViewModel[];
  campaigns: Array<HeaderCampaignItemViewModel>;
  visible: boolean;
  menuTitle?: string;
  setIsLoading: (boolean) => void;
  isRenderFromDom?: boolean;
}

const MegaMenu = ({
  items,
  campaigns,
  visible,
  menuTitle = '',
  setIsLoading,
  isRenderFromDom = false,
}: MegaMenuProps) => {
  const [scrollPositionY, setScrollPositionY] = useState<number>(105);
  useEffect(() => {
    if (visible && window.scrollY < 105) {
      const newScrollPosition = 105 - window.scrollY;
      setScrollPositionY(newScrollPosition);
    }
  }, [visible]);

  return (
    <Wrapper topMargin={scrollPositionY}>
      <ItemsWrapper>
        {items?.map((item, index) => {
          return (
            <Item key={`${item.title}-${index}`}>
              {item.href === '' ? (
                <ItemTitle>{item.title}</ItemTitle>
              ) : (
                <Link
                  href={item.href ?? ''}
                  prefetch={false}
                  title={item.title}
                  onClick={(e) => {
                    if (menuTitle === 'Tekne') {
                      e.preventDefault();
                      window.open(item.href, '_blank');
                    } else {
                      setIsLoading?.(true);
                    }
                    if (menuTitle === 'Otel')
                      productImpression({
                        item_list_location: 'Category Header',
                        item_list_id: item?.title || '',
                        type: 'hotel',
                      });
                    if (menuTitle === 'Kıbrıs Otelleri')
                      item?.title?.includes('Paket')
                        ? productImpression({
                            item_list_location: 'Category Header',
                            item_list_id: item?.title,
                            type: 'package',
                          })
                        : productImpression({
                            item_list_location: 'Category Header',
                            item_list_id: item?.title?.includes('Oteller')
                              ? item?.title
                              : `${item?.title} Otelleri`,
                            type: 'hotel',
                          });
                    if (menuTitle === 'Tur')
                      productImpression({
                        item_list_location: 'Category Header',
                        item_list_id: item?.title || '',
                        type: 'tour',
                      });
                    if (menuTitle === 'Gemi')
                      productImpression({
                        item_list_location: 'Category Header',
                        item_list_id: item?.title || '',
                        type: 'ship',
                      });
                    if (menuTitle === 'Uçak')
                      productImpression({
                        item_list_location: 'Category Header',
                        item_list_id: item?.title || '',
                        type: 'flight',
                      });
                  }}
                >
                  <ItemTitle>{item.title}</ItemTitle>
                </Link>
              )}
              <LinksItems>
                {item?.items?.map((link, index) => {
                  if (menuTitle === 'Tekne')
                    return (
                      <ItemLink
                        key={`${link.name}-${index}`}
                        href={link.href}
                        title={link.name}
                        prefetch={false}
                        target='_blank'
                        rel='nofollow opener noreferrer'
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(link.href, '_blank');
                        }}
                      >
                        {link.name}
                      </ItemLink>
                    );
                  else
                    return link.backgroundColor && link.textColor ? (
                      <ItemLinkContainer backgroundColor={link.backgroundColor}>
                        <ItemLinkDyanmic
                          color={link.textColor}
                          key={`${link.name}-${index}`}
                          href={link.href}
                          onClick={() => {
                            setIsLoading?.(true);
                            addMenuClickEventsToGTM(
                              menuTitle + ' - ' + item.title + ' - ' + link.name
                            );
                            if (menuTitle === 'Otel') {
                              productImpression({
                                item_list_location: 'Category Header',
                                item_list_id: link.name.includes('Oteller')
                                  ? link.name
                                  : `${link.name} Otelleri`,
                                type: 'hotel',
                              });
                            }
                            if (menuTitle === 'Kıbrıs Otelleri')
                              link.name.includes('Paket')
                                ? productImpression({
                                    item_list_location: 'Category Header',
                                    item_list_id: link.name,
                                    type: 'package',
                                  })
                                : productImpression({
                                    item_list_location: 'Category Header',
                                    item_list_id: link.name.includes('Oteller')
                                      ? link.name
                                      : `${link.name} Otelleri`,
                                    type: 'hotel',
                                  });
                            if (menuTitle === 'Tur') {
                              productImpression({
                                item_list_location: 'Category Header',
                                item_list_id: link?.name || '',
                                type: 'tour',
                              });
                            }
                            if (menuTitle === 'Gemi') {
                              productImpression({
                                item_list_location: 'Category Header',
                                item_list_id: link?.name || '',
                                type: 'ship',
                              });
                            }
                            if (menuTitle === 'Uçak') {
                              productImpression({
                                item_list_location: 'Category Header',
                                item_list_id: link?.name || '',
                                type: 'flight',
                              });
                            }
                          }}
                          title={link.name}
                          prefetch={false}
                        >
                          {link.name}
                        </ItemLinkDyanmic>
                      </ItemLinkContainer>
                    ) : (
                      <ItemLink
                        key={`${link.name}-${index}`}
                        href={link.href}
                        onClick={() => {
                          setIsLoading?.(true);
                          addMenuClickEventsToGTM(
                            menuTitle + ' - ' + item.title + ' - ' + link.name
                          );
                          if (menuTitle === 'Otel') {
                            productImpression({
                              item_list_location: 'Category Header',
                              item_list_id: link.name.includes('Oteller')
                                ? link.name
                                : `${link.name} Otelleri`,
                              type: 'hotel',
                            });
                          }
                          if (menuTitle === 'Kıbrıs Otelleri')
                            link.name.includes('Paket')
                              ? productImpression({
                                  item_list_location: 'Category Header',
                                  item_list_id: link.name,
                                  type: 'package',
                                })
                              : productImpression({
                                  item_list_location: 'Category Header',
                                  item_list_id: link.name.includes('Oteller')
                                    ? link.name
                                    : `${link.name} Otelleri`,
                                  type: 'hotel',
                                });
                          if (menuTitle === 'Tur') {
                            productImpression({
                              item_list_location: 'Category Header',
                              item_list_id: link?.name || '',
                              type: 'tour',
                            });
                          }
                          if (menuTitle === 'Gemi') {
                            productImpression({
                              item_list_location: 'Category Header',
                              item_list_id: link?.name || '',
                              type: 'ship',
                            });
                          }
                          if (menuTitle === 'Uçak') {
                            productImpression({
                              item_list_location: 'Category Header',
                              item_list_id: link?.name || '',
                              type: 'flight',
                            });
                          }
                        }}
                        title={link.name}
                        prefetch={false}
                      >
                        {link.name}
                      </ItemLink>
                    );
                })}

                {item?.more?.[0]?.name ? (
                  <ItemSubItemBox
                    prefetch={false}
                    href={item.more[0].href}
                    onClick={() => {
                      addMenuClickEventsToGTM(
                        menuTitle +
                          ' - ' +
                          item.title +
                          ' - ' +
                          item?.more?.[0].name
                      );
                    }}
                  >
                    <ItemSubItemLink>{item.more[0].name}</ItemSubItemLink>
                    <CustomIcon
                      icon={RightArrowIcon}
                      fontSize={24}
                      paletteColor='darkGrey'
                    />
                  </ItemSubItemBox>
                ) : null}
              </LinksItems>
            </Item>
          );
        })}
      </ItemsWrapper>
      <PhotosWrapper>
        {campaigns?.map((item) => (
          <PhotosItem key={item.title}>
            {menuTitle === 'Tekne' ? (
              <Link
                href={item?.text ?? ''}
                style={{ width: '100%' }}
                prefetch={false}
                target='_blank'
                rel='nofollow noopener noreferrer'
                onClick={(e) => {
                  e.preventDefault();
                  window.open(item?.text ?? '', '_blank');
                }}
              >
                {item?.images?.map((imageItem) =>
                  !isRenderFromDom ? (
                    <PhotosItemImage
                      key={imageItem?.url}
                      image={imageItem?.url}
                    />
                  ) : null
                )}
                <PhotosItemContent>
                  <div>
                    <PhotosItemLabel>{item.title}</PhotosItemLabel>
                    <PhotosItemBorder />
                  </div>
                  <div>
                    <CustomIcon
                      icon={ChevronRight}
                      fontSize={15}
                      paletteColor='white'
                    />
                  </div>
                </PhotosItemContent>
              </Link>
            ) : (
              <Link
                href={item?.text ?? ''}
                style={{ width: '100%' }}
                onClick={() => {
                  item.title &&
                    menuTitle &&
                    addMenuClickEventsToGTM(menuTitle + ' - ' + item.title);
                  if (menuTitle === 'Otel')
                    productImpression({
                      item_list_location: 'Category Header',
                      item_list_id: item?.title?.includes('Oteller')
                        ? item?.title
                        : `${item?.title} Otelleri`,
                      type: 'hotel',
                    });
                  if (menuTitle === 'Tur')
                    productImpression({
                      item_list_location: 'Category Header',
                      item_list_id: item?.title || '',
                      type: 'tour',
                    });
                  if (menuTitle === 'Gemi')
                    productImpression({
                      item_list_location: 'Category Header',
                      item_list_id: item?.title || '',
                      type: 'ship',
                    });
                  if (menuTitle === 'Uçak')
                    productImpression({
                      item_list_location: 'Category Header',
                      item_list_id: item?.title || '',
                      type: 'flight',
                    });
                }}
                prefetch={false}
              >
                {item?.images?.map((imageItem) =>
                  !isRenderFromDom ? (
                    <PhotosItemImage
                      key={imageItem?.url}
                      image={imageItem?.url}
                    />
                  ) : null
                )}
                <PhotosItemContent>
                  <div>
                    <PhotosItemLabel>{item.title}</PhotosItemLabel>
                    <PhotosItemBorder />
                  </div>
                  <ChevronContainer>
                    <CustomIcon
                      icon={ChevronRight}
                      fontSize={15}
                      paletteColor='white'
                    />
                  </ChevronContainer>
                </PhotosItemContent>
              </Link>
            )}
          </PhotosItem>
        ))}
      </PhotosWrapper>
    </Wrapper>
  );
};

export default MegaMenu;
